var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { Query } from 'react-apollo';
import { localDataQuery } from '../gql/localData';
import { ErrorDialog } from './reusable/ErrorDialog';
export var GlobalDialogs = function (props) { return (React.createElement(Query, __assign({}, localDataQuery()), function (_a) {
    var data = _a.data, client = _a.client;
    return (React.createElement(ErrorDialog, { open: data.errorDialog, message: data.errorMessage, onClose: function () {
            return client.writeData({
                data: {
                    errorDialog: false,
                    errorMessage: '',
                    errorCode: '',
                },
            });
        } }));
})); };



//////////////////
// WEBPACK FOOTER
// ./src/components/GlobalDialogs.tsx
// module id = 2017
// module chunks = 81